import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {CommonResponse} from '../interfaces/home';

@Injectable({
  providedIn: 'root'
})
export class OperatingEntityService {

  constructor(private http: HttpClient) { }
  baseUrl = environment.baseUrl+'OperatingEntity/';
  // fetch all OperatingEntity in the database
  allData(): Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl);
  }

  getOperatingEntityAndSBUProportion(): Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl + 'SbuProportion/');
  }
  getOperatingEntity(id: any):Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl +id);
  }
  getOperatingEntityByName(name: any):Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl + 'name/' + name);
  }
  postOperatingEntity(data: any){
    return this.http.post(this.baseUrl, data);
  }
  deleteOperatingEntity(id: any){
    return this.http.delete(this.baseUrl +id);
  }
  updateOperatingEntity(id: any, data: any){
    return this.http.put(this.baseUrl +id, data);
  }
}
